import { useState, type ReactElement } from 'react';
import type { Alteration, NotificationEvent } from '@tailoring-crm/shared';
import {
  useAlterationMessagePreview,
  useAlterationMessages,
  useSendAlterationMessage,
} from '../../lib/alterations/use-alterations.js';
import { CustomerUpdatesCard } from '../orders/order-updates-card.js';

/**
 * "Alteration booked" and "Alteration ready", sent by a tap — the order card's twin, on the
 * alteration's own page. Without Relay the preview opens WhatsApp with the message typed, which
 * for a walk-in is their only slip for the garment they left behind.
 */
export function AlterationUpdatesCard({
  alteration,
}: {
  alteration: Alteration;
}): ReactElement | null {
  const [composing, setComposing] = useState<NotificationEvent | null>(null);
  const messages = useAlterationMessages(alteration.id);
  const preview = useAlterationMessagePreview(alteration.id, composing);
  const send = useSendAlterationMessage(alteration.id);

  return (
    <CustomerUpdatesCard
      customerName={alteration.customerName}
      data={messages.data}
      composing={composing}
      onCompose={setComposing}
      preview={preview.data}
      previewPending={preview.isPending}
      send={send}
    />
  );
}

export default AlterationUpdatesCard;
